import { FormWizard } from "react-material-formik-wizard";

import { Box } from "@mui/material";

import OrderReviewStep from "examples/OrderStepper/components/OrderReviewStep";
import PersonalDetailsStep from "examples/OrderStepper/components/PersonalDetailsStep";
import PolicyCoverPeriodStep from "examples/OrderStepper/components/PolicyCoverPeriodStep";
import PolicyStep from "examples/OrderStepper/components/PolicyStep";
import RequirementsStep from "examples/OrderStepper/components/RequirementsStep";

export default function OrderStepper() {
  const steps = [
    {
      component: PolicyStep,
      title: "Selected Policy Cover",
    },
    {
      component: PersonalDetailsStep,
      title: "Personal Details",
    },
    {
      component: RequirementsStep,
      title: "Cover Requirements",
    },
    {
      component: PolicyCoverPeriodStep,
      title: "Policy Cover Period",
    },
    {
      component: OrderReviewStep,
      title: "Policy Order Review",
    },
  ];

  const doSubmit = (values) => {
    // alert("submitting: " + JSON.stringify(values));
    console.log("submitting values", values);
  };

  return (
    <Box sx={{ width: "100%", paddingTop: 15 }}>
      <FormWizard
        displayProgress={true}
        formComponents={steps}
        doSubmit={doSubmit}
        successTitle={"Success"}
        successTitleComponent={"h1"}
        successMessage={"Your cover order has been submitted"}
        successMessageComponent={"h5"}
      />
    </Box>
  );
}
